var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/carousel-module-pause.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg class=\"i-pause\" viewBox=\"0 0 11 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com -->\n    <title>Group 3</title>\n    <desc>Created with Sketch.</desc>\n    <g class=\"i-pause\" stroke=\"none\" stroke-width=\"1\">\n        <g id=\"XS_AN_Homepage\" transform=\"translate(-54.000000, -402.000000)\">\n            <g id=\"Group-4-Copy\" transform=\"translate(40.000000, 390.000000)\">\n                <g id=\"Group-3\" transform=\"translate(14.000000, 12.000000)\">\n                    <rect id=\"Rectangle\" x=\"0\" y=\"0\" width=\"3\" height=\"16\"></rect>\n                    <rect id=\"Rectangle-Copy\" x=\"8\" y=\"0\" width=\"3\" height=\"16\"></rect>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/carousel-module-pause.j2"] , dependencies)